import React, { useState, useEffect } from "react";
import Design from "./Design";
import {
  fetchTopDetails,
  fetchTopWeeklyEvents,
  fetchUserGiftsTop,
  fetchUserGiftsTopHours,
  RoleEvent,
} from "../../services/Weekly_star";
const NewEvents = () => {
  const [roleEventData, setRoleEventData] = useState(null);
  const [topWeeklyData, setTopWeeklyData] = useState(null);
  const [userGiftsTopHours, setUserGiftsTopHours] = useState(null);
  const [userGiftsTop, setUserGiftsTop] = useState(null);
  const [topDetails, setTopDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        // First API call
        const data2 = await fetchTopWeeklyEvents();
        setTopWeeklyData(data2.data);

        // Only execute other APIs if the first one is successful
        if (data2 && data2.data) {
          try {
            // Execute other APIs in parallel for better performance
            const [data3, data4, data5, data1] = await Promise.all([
              fetchUserGiftsTopHours(),
              fetchUserGiftsTop(),
              fetchTopDetails(),
              RoleEvent(),
            ]);

            setUserGiftsTopHours(data3.data);
            setUserGiftsTop(data4.data);
            setTopDetails(data5.data);
            setRoleEventData(data1.data);
          } catch (secondaryError) {
            console.error("Secondary APIs error:", secondaryError);
            // You can choose to set error state here or just log it
            // setError(`Some data failed to load: ${secondaryError.message}`);
          }
        }
      } catch (err) {
        setError(err.message);
        console.error("Primary API failed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <Design
        roleEventData={roleEventData}
        topWeeklyData={topWeeklyData}
        userGiftsTopHours={userGiftsTopHours}
        userGiftsTop={userGiftsTop}
        topDetails={topDetails}
      />
    </div>
  );
};

export default NewEvents;
// there is two end points want to replace them
// structure of image
// token
//responsive
